// src/ConsumerApp/Screens/Account/AccountLayout.js

import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../../DesignSystem/Navigation/Navbar';
import CenteredContainer from '../../DesignSystem/Layout/CenteredContainer';
import AccountSidebar from './AccountSidebar';

export default function AccountLayout() {
  const location = useLocation();
  const rawPath = location.pathname.toLowerCase().replace(/\/+$/, '');

  // Track window width reactively
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // When on mobile: if pathname is '/consumer/account', show ONLY the sidebar hub.
  // If the pathname has sub-routes like '/orders', '/wallet', etc., show ONLY the Outlet.
  const isAccountRoot = rawPath === '/consumer/account' || rawPath === '/consumer/account/';

  return (
    <div style={styles.pageShell}>
      <style>{`
        /* ══════════════════════════════════════════════════════════
           DESKTOP & TABLET (> 900px): Permanent 2-Column Split
           ══════════════════════════════════════════════════════════ */
        .bb-account-layout-row {
          display: flex;
          gap: 28px;
          padding: 24px 0 48px 0;
          align-items: flex-start;
          width: 100%;
          box-sizing: border-box;
        }

        .bb-account-sidebar-col {
          width: 320px;
          flex-shrink: 0;
          position: sticky;
          top: 96px;
          display: block;
        }

        .bb-account-outlet-col {
          flex: 1;
          min-width: 0;
          display: block;
        }

        /* ══════════════════════════════════════════════════════════
           MOBILE (<= 900px): Progressive Drill-down
           1. /consumer/account          -> Profile card + Menu list ONLY
           2. /consumer/account/orders   -> Orders List ONLY (sidebar hidden)
           3. /consumer/account/orders/:id -> Order Detail ONLY
           ══════════════════════════════════════════════════════════ */
        @media (max-width: 900px) {
          .bb-account-layout-row {
            flex-direction: column;
            gap: 0;
            padding: 12px 0 36px 0;
          }

          .bb-account-sidebar-col {
            width: 100% !important;
            max-width: 100% !important;
            position: static !important;
            display: ${isAccountRoot ? 'block' : 'none'} !important;
          }

          .bb-account-outlet-col {
            width: 100% !important;
            display: ${isAccountRoot ? 'none' : 'block'} !important;
          }
        }
      `}</style>

      <Navbar />

      <CenteredContainer>
        <div className="bb-account-layout-row">
          {/* On Mobile: Visible when on /consumer/account. On Desktop: Always visible on left */}
          {(!isMobile || isAccountRoot) && (
            <aside className="bb-account-sidebar-col">
              <AccountSidebar />
            </aside>
          )}

          {/* On Mobile: Visible when on sub-routes (/orders, /wallet). On Desktop: Always visible on right */}
          {(!isMobile || !isAccountRoot) && (
            <main className="bb-account-outlet-col">
              <Outlet />
            </main>
          )}
        </div>
      </CenteredContainer>
    </div>
  );
}

const styles = {
  pageShell: {
    backgroundColor: '#FAF9F6',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
};